import { forwardRef } from 'react';
import { getAlpineClientUrl } from 'utils/alpine-cart-bridge';

type AlpineClientIframeProps = {
  onLoad?: () => void;
};

/**
 * Hidden iframe that loads the Alpine Client website.
 * Used for postMessage communication to add items to cart.
 * This component should be rendered at the page level to ensure
 * the iframe is loaded before cart operations are attempted.
 */
const AlpineClientIframe = forwardRef<
  HTMLIFrameElement,
  AlpineClientIframeProps
>(({ onLoad }, ref) => {
  const alpineClientUrl = getAlpineClientUrl();

  if (!alpineClientUrl) {
    console.warn('REACT_APP_ALPINE_CLIENT_URL is not configured');
    return null;
  }

  return (
    <iframe
      ref={ref}
      id='alpineClientIframe'
      src={alpineClientUrl}
      onLoad={onLoad}
      style={{
        position: 'absolute',
        width: '1px',
        height: '1px',
        top: '-9999px',
        left: '-9999px',
        visibility: 'hidden',
        pointerEvents: 'none'
      }}
      title='Alpine Client Integration'
      aria-hidden='true'
    />
  );
});

AlpineClientIframe.displayName = 'AlpineClientIframe';

export default AlpineClientIframe;
